<template>
  <div id="contents">
    <nav id="snb">
      <ul>
        <li class="on"><a href="#cnt0"><span>서브메뉴0</span></a></li>
        <li class="#"><a href="#cnt1"><span>서브메뉴1</span></a></li>
        <li><a href="#cnt2"><span>서브메뉴2</span></a></li>
        <li><a href="#cnt3"><span>서브메뉴3</span></a></li>
        <li class="#" style="display:none"><a href="#footer"><span>footer</span></a></li>
      </ul>
    </nav>

    <div class="section-group">
      <section class="section main-visual-section" id="cnt0">
        <div class="inner">
          <h2 class="section-title">믿음과 신뢰를 기반으로<br>정성드린 마케팅 전문 기업</h2>
          <img src="../resource/images/main_visual.png" class="img" alt=""/>

        </div>
      </section>

      <section class="section main-intro-section" id="cnt1">
        <div class="inner">
          <h2 class="section-title">ADMASS</h2>
          <ul class="main-intro-list">
            <li>
              <span class="title">설립연도</span>
              <span class="value counter"><var id="count0">2018</var></span>
            </li>
            <li>
              <span class="title">누적 계약수</span>
              <span class="value counter"><var id="count1">3000</var></span>
            </li>
            <li>
              <span class="title">재계약율</span>
              <span class="value counter"><var id="count2">80</var> %</span>
            </li>
          </ul>
        </div>
      </section>

      <section class="section main-info-section" id="cnt2">
        <div class="inner">
          <div class="title-wrap">

            <h2 class="section-title"><span class="tx-mainColor">Premium</span> Marketing Service</h2>
            <p class="sub-desc">애드매스는 고객과의 신뢰와 소통 수단을 기반으로<br>
              다양한 마케팅을 보다 전문적으로 서비스해 드립니다.</p>
          </div>
          <img src="../resource/images/company_info04.png" class="img" alt=""/>
        </div>
      </section>

      <section class="section main-service-section" id="cnt3">
        <div class="inner">
          <h3 class="section-sub-title">서비스 소개</h3>
          <ul class="main-service-list">
            <li @click="this.goPage('/service/hometown')">
                <h4 class="title">SKB 우리동네광고</h4>
                <img src="../resource/images/service_intro01.png" />
                <p class="desc">지역 타겟팅으로 원하는 지역을 선택해 광고</p>
            </li>
            <li @click="this.goPage('/service/skylife')">
                <h4 class="title">KT스카이라이프 IPTV광고</h4>
                <img src="../resource/images/service_intro02.png" />
                <p class="desc">지역 타겟팅으로 원하는 지역을 선택해 광고</p>
            </li>
            <li @click="this.goPage('/service/experience')">
                <h4 class="title">체험단 마케팅</h4>
                <img src="../resource/images/service_intro03.png" />
                <p class="desc">업종 맞춤형 전문 인플루언서를 통한 콘텐츠 노출 </p>
            </li>
            <li @click="this.goPage('/service/reporter')">
                <h4 class="title">기자단 마케팅</h4>
                <img src="../resource/images/service_intro04.png" />
                <p class="desc">확실한 정보와 신뢰성 상승을 바탕으로 이미지 상승</p>
            </li>
            <li @click="this.goPage('/service/insta')">
                <h4 class="title">인스타 마케팅</h4>
                <img src="../resource/images/service_intro05.png" />
                <p class="desc">인맥부터 정보공유까지 다양한 스타일로 광고</p>
            </li>
            <li @click="this.goPage('/service/viral')">
                <h4 class="title">바이럴 마케팅</h4>
                <img src="../resource/images/service_intro06.png" />
                <p class="desc">자발적으로 널리 퍼지며 바이러스 같은 효과</p>
            </li>
          </ul>
        </div>
      </section>

      <common-footer/>
      <div class="fixed-menu">
        <a href="/contact-us" class="btn-chat"><img src="../resource/images/ico_chat.png" alt=""/></a>
        <button type="button" class="btn-top"><img src="../resource/images/ico_top.png" alt="" @click="this.scrollTop"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CommonFooter from '@/layout/Footer'

var className = "section";// 적용할 클래스명
var currentScroll = 0;// 지금의 스크롤 위치를 담을 변수
var tim;// 애니메이션 효과를 주기위한 function 명 선언
var elm = document.getElementsByClassName(className);


export default {
  name: 'page-home',
  components: {
    CommonFooter
  },
  data() {
    return {
      snbIndicator: document.querySelectorAll("#snb ul li a"),
      maxNum : [2018, 3000, 30]
    }
  },
  mounted() {
    document.body.classList.add('main');

    this.snbIndicator = document.querySelectorAll("#snb ul li a");
    if (window.innerWidth > 1439 && window.innerHeight > 749) {
      setTimeout(() => {
        for (var i = 0; i < this.snbIndicator.length; i++) {
          this.snbIndicator[i].addEventListener("click", this.indicatorClick);
        }
        elm[0].classList.add("on");
        // section 에 각각 마우스 휠 감지/section 클래스 개수만큼 실행
        for (var j = 0; j < elm.length; j++) {
          elm[j].addEventListener("mousewheel", this.scrollMove, false);// 휠감지
          elm[j].addEventListener("DOMMouseScroll", this.scrollMove, true); // firefox 용 휠처리
        }
      }, 500);
    } else {
      this.scroll();
    }
  },
  methods: {
    goPage(dest) {
      location.href = dest;
    },
    scrollMove(e) {
      e.preventDefault();// 스크롤 취소시킴(이걸 안할경우 도중에 명령을 받아 화면이 덜덜 거릴수 있음)

      var delta = 0;// 휠값처리
      let event = window.event;
      if (event.wheelDelta) {
        delta = event.wheelDelta / 120;
        if (window.opera) delta = -delta;
      } else if (event.detail)
        delta = -event.detail / 3;

      var p = e.currentTarget.parentElement;// 여러개일경우 다른 selector 을 확인하기위한 상위 dom 으로 이동
      var index = Array.prototype.indexOf.call(p.children, e.currentTarget);// 몇번째 dom 인지 저장 마우스 이벤트가 발생한 영역
      var elmArr = e.currentTarget.parentElement.children;// 같은 위치의 돔목록 을 저장//5개

      currentScroll = document.documentElement.scrollTop || document.body.scrollTop;// 지금의 스크롤 위치 저장
      var NextTarget = currentScroll; // 다음위치의 좌표(기본이므로 현재의 Y 좌표 저장)

      //수정
      var cntPosY = new Array(elmArr.length);
      for (var i = 0; i < elmArr.length; i++) {//01234 footer 포함
        cntPosY[i] = elmArr[i].offsetTop
      }

      // 마우스휠 위로
      if (delta > 0) {
        if (index > 0) { // 맨처음 지점 제외
          for (var k = 0; k < elmArr.length; k++) {
            //elmArr[k].classList.remove("on");
            this.snbIndicator[k]?.parentElement.classList.remove("on")
          }

          //문서의 마지막에 위치할 경우 스크롤 마지막 인덱스로 강제 이동
          if (currentScroll < cntPosY[4] && currentScroll > cntPosY[3]) {
            NextTarget = cntPosY[index];
            this.snbIndicator[index]?.parentElement.classList.add("on")
          } else {
            elmArr[index].parentElement.classList.add("on")

            NextTarget = cntPosY[index - 1]

            this.snbIndicator[index - 1]?.parentElement.classList.add("on")
          }
        }

      } else if (delta < 0) {// 마우스휠 아래로
        if (index < elmArr.length) {//0,1,2,3,4 맨마지막 지점 제외
          for (var l = 0; l < elmArr.length; l++) {
            // elmArr[l].classList.remove("on");
            this.snbIndicator[l]?.parentElement.classList.remove("on")
          }
          if(index === 0) {
            // this.countup();
          }
          elmArr[index + 1].classList.add("on");
          NextTarget = cntPosY[index + 1];
          this.snbIndicator[index + 1]?.parentElement.classList.add("on")
        }
      }

      // 애니메이션
      if (!(delta > 0 && index === 0)) {
        clearInterval(tim);// 에니메이션 초기화
        tim = setInterval(tran, 1);// 애니메이션 실행
      }

      function tran() { // 애니메이션 function
        // 이동속도 숫자가 작아질수록 느려짐
        var speed = 10;
        // 현재 스크롤과 이동후 스크롤이 같으면 정지시킨다
        if (currentScroll == NextTarget) {
          clearInterval(tran);
        } else {
          // 스크롤을 위로 올릴 경우
          if (currentScroll - speed > NextTarget) {
            currentScroll -= speed;
          }
          // 스크롤을 내릴 경우
          else if (currentScroll + speed < NextTarget) {
            currentScroll += speed;
          }
          // 스크롤이 속도로 지정된 변수보다 작을 경우 강제적으로 맞춰준다
          else {
            currentScroll = NextTarget;
          }
          // 스크롤위치 변경
          window.scrollTo(0, currentScroll);
        }
      }
    },

    scroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.screenY;
      document.querySelectorAll("section").forEach(item => {
        if(scrollTop > item.offsetTop - window.innerHeight / 1){
          item.classList.add("on");
        }
      });
      window.requestAnimationFrame(this.scroll);
    },

    indicatorClick(e) {
      e.preventDefault();

      var cntPosY = new Array(elm.length);
      const nodes = [...e.currentTarget.parentElement.parentElement.children];
      var index = nodes.indexOf(e.currentTarget.parentElement);

      for (var i = 0; i < elm.length; i++) {
        cntPosY[i] = elm[i].offsetTop;
      }

      for (var j = 0; j < this.snbIndicator.length; j++) {
        this.snbIndicator[j].parentElement.classList.remove("on");
      }
      e.currentTarget.parentElement.classList.add("on");
      var NextTarget = cntPosY[index];

      // 애니메이션
      clearInterval(tim);// 에니메이션 초기화
      tim = setInterval(tran, 1);// 애니메이션 실행
      function tran() { // 애니메이션 function
        // 이동속도 숫자가 작아질수록 느려짐
        var speed = 10;
        // 현재 스크롤과 이동후 스크롤이 같으면 정지시킨다
        if (currentScroll == NextTarget) {
          clearInterval(tran);
        } else {
          // 스크롤을 위로 올릴 경우
          if (currentScroll - speed > NextTarget) {
            currentScroll -= speed;
          }
          // 스크롤을 내릴 경우
          else if (currentScroll + speed < NextTarget) {
            currentScroll += speed;
          }
          // 스크롤이 속도로 지정된 변수보다 작을 경우 강제적으로 맞춰준다
          else {
            currentScroll = NextTarget;
          }
          // 스크롤위치 변경
          window.scrollTo(0, currentScroll);
        }
      }
    },
    scrollTop() {
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    },

    countup() {
      for(let i=0; i<3; i++) {
        this.countingType1(i);
      }
    },

    countingType1(k){
      const element = document.querySelector('#count'+k)
      if(this.maxNum[k] == 0){
        element.innerHTML = '0';
      } else {
        /* 입력한 숫자를 33번에 걸쳐 0부터 올림. */
        const each = Math.ceil(this.maxNum[k]/30);
        let time = 0

        for(let i=0; i<=this.maxNum[k]; i+=each){
          setTimeout(() => {
            element.innerHTML = i;
          }, 45*time);
          /* 딱 떨어지지 않는 숫자를 마지막에 그 숫자로 만들어주기 위함 */
          if(i+each > this.maxNum[k]){
            setTimeout(() => {
              element.innerHTML = this.maxNum[k];
            }, 45*(time+1));
          }
          time++;
        }
      }
    },

  }
}

</script>

<style>

</style>